// src/utils/createTempDesign.js
export function createTempDesign(styleChoiceId, opts = {}) {
  const now = Date.now();
  const tempId = opts.tempId || `temp-${styleChoiceId}`;
  return {
    Id: tempId,
    DesignStyleChoiceid: parseInt(styleChoiceId, 10),
    ProductTypeId: 15,
    DesignName: opts.designName || 'Wall A',
    Matrix: opts.matrix || { Rows: 0, Columns: 0, Segments: [] },
    Products: opts.products || [],
    Cart: opts.cart || [],
    QuickAccessBars: false,
    Created: new Date().toISOString(),
    LastModified: new Date().toISOString(),
    ModularDesignType: 'Cabinet',
    Version: 1,
    IsLocked: false,
    ProductsHash: null,
    ProductParentIds: {},
    isTemp: true,
    ...opts.extra // allow override/extension
  };
}
